import moment from 'moment-timezone';

export function setTimeZone (datetime: string, timezone = 'Hongkong') {
  if (!timezone) timezone = 'Hongkong';
  try {
    return moment.utc(datetime).tz(timezone).format('YYYY-MM-DD hh:mm A');
  } catch (error) {
    console.log(error);
    return moment.utc(datetime).local().format('YYYY-MM-DD hh:mm A');
  }
}
